import React, { useEffect, useState } from 'react';
import { AppButton, AppCheckbox, AppFormField, AppInput, AppModal, AppSelect } from '../ui';
import { KKP_DISTRIB_MOIS } from '../../utils/kkpDistribPalette';

const SUPPORTS = [
  { value: 'set', label: 'SET' },
  { value: 'mag', label: 'MAG' },
  { value: 'both', label: 'MAG + SET' },
];

const EMPTY = {
  nom: '',
  support: 'set',
  mois: [],
  include_zero: false,
};

const KkpDistribOrdreModal = ({ show, zoneLabel, saving, onClose, onSubmit }) => {
  const [form, setForm] = useState(EMPTY);

  useEffect(() => {
    if (show) setForm(EMPTY);
  }, [show]);

  const toggleMois = (value) => {
    setForm((prev) => {
      const has = prev.mois.includes(value);
      return {
        ...prev,
        mois: has ? prev.mois.filter((m) => m !== value) : [...prev.mois, value].sort((a, b) => a - b),
      };
    });
  };

  return (
    <AppModal
      show={show}
      title={`Nouvel ordre de tournée${zoneLabel ? ` · ${zoneLabel}` : ''}`}
      onClose={onClose}
      closeDisabled={saving}
      contentAs="form"
      contentProps={{
        onSubmit: (e) => {
          e.preventDefault();
          onSubmit(form);
        },
      }}
      footer={(
        <>
          <AppButton variant="outline-secondary" onClick={onClose} disabled={saving}>
            Annuler
          </AppButton>
          <AppButton type="submit" loading={saving} loadingLabel="Création…" disabled={saving || !form.nom.trim()}>
            Créer l’ordre
          </AppButton>
        </>
      )}
    >
      <p className="text-secondary-light text-sm">
        Enregistrez un ordre spécifique (ex. SET janvier et août) sans modifier l’ordre catalogue.
      </p>
      <AppFormField label="Nom" htmlFor="ordre-nom" required>
        <AppInput
          id="ordre-nom"
          required
          placeholder="SET janvier et août"
          value={form.nom}
          onChange={(e) => setForm((f) => ({ ...f, nom: e.target.value }))}
        />
      </AppFormField>
      <AppFormField label="Support" htmlFor="ordre-support">
        <AppSelect
          id="ordre-support"
          value={form.support}
          onChange={(e) => setForm((f) => ({ ...f, support: e.target.value }))}
        >
          {SUPPORTS.map((s) => (
            <option key={s.value} value={s.value}>{s.label}</option>
          ))}
        </AppSelect>
      </AppFormField>
      <AppFormField label="Mois concernés">
        <div className="kkp-distrib-mois-grid">
          {KKP_DISTRIB_MOIS.map((m) => (
            <label key={m.value} className={`kkp-distrib-mois-chip ${form.mois.includes(m.value) ? 'is-active' : ''}`}>
              <input
                type="checkbox"
                className="d-none"
                checked={form.mois.includes(m.value)}
                onChange={() => toggleMois(m.value)}
              />
              {m.label.slice(0, 3)}
            </label>
          ))}
        </div>
      </AppFormField>
      <AppCheckbox
        id="ordre-zero"
        label="Inclure les points à quantité 0"
        checked={form.include_zero}
        onChange={(e) => setForm((f) => ({ ...f, include_zero: e.target.checked }))}
      />
    </AppModal>
  );
};

export default KkpDistribOrdreModal;
